<template>
    <products-layout>
        <div class="backoffice-products">
            <div class="page-header">
                <div class="left">
                    <h2 class="page-title">{{ $page.props.lang.title || "Products List" }}</h2>
                </div>
                <div class="right">
                    <v-btn color="primary" dark @click="newProductModal = true">
                        <v-icon small>mdi-plus</v-icon>
                        <span v-if="$vuetify.breakpoint.mdAndUp" class="ml-2">{{ $page.props.lang.newProduct || "New product" }}</span>
                    </v-btn>
                </div>
            </div>
            <div class="filter-section">
                <v-text-field v-model="form.search" :label="$page.props.lang.filter_search || 'Search'" background-color="#FFFFFF" outlined dense prepend-inner-icon="mdi-magnify" class="table-search"></v-text-field>
                <v-select v-model="selectedCategoryId" @change="categorySelected" :items="categoryList" :label="$page.props.lang.category || 'Category'" item-text="name" item-value="id" clearable outlined dense class="table-select"></v-select>
                <v-btn color="regular" @click="resetFilters">{{ $page.props.lang.reset || "Reset" }}</v-btn>

            </div>
            <v-dialog v-model="newProductModal" max-width="500px">
                <v-card>
                   <div class="modal-header">
                    <h4 class="modal-headline">{{ $page.props.lang.newProduct || "New product" }}</h4>
                    <div class="tools">
                        <v-btn icon @click="newProductModal = false"><v-icon>mdi-close</v-icon></v-btn>
                    </div>
                </div>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12">
                                    <p class="custom-label">{{ $page.props.lang.name || 'Name' }}</p>
                                    <v-text-field v-model="newProduct.name" 
                                    :error-messages="responseErrors.name" :hide-details="!responseErrors.name"
                                    @focus="responseErrors.name=''" outlined dense></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <p class="custom-label">{{ $page.props.lang.sku || 'Sku' }}</p>
                                    <v-text-field v-model="newProduct.sku" 
                                    :error-messages="responseErrors.sku" :hide-details="!responseErrors.sku"
                                    @focus="responseErrors.sku=''" outlined dense></v-text-field>
                                </v-col>
                                <!-- <v-col cols="12">
                                    <p class="custom-label">{{ $page.props.lang.quantity || 'Quantity' }}</p>
                                    <v-text-field v-model="newProduct.qty" 
                                    :error-messages="responseErrors.qty" :hide-details="!responseErrors.qty"
                                    @focus="responseErrors.qty=''" outlined dense></v-text-field>
                                </v-col> -->
                                <v-col cols="12">
                                    <p class="custom-label">{{ $page.props.lang.unit || 'Unit' }}</p>
                                    <v-text-field v-model="newProduct.unit" 
                                    :error-messages="responseErrors.unit" :hide-details="!responseErrors.unit"
                                    @focus="responseErrors.unit=''" outlined dense></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <p class="custom-label">{{ $page.props.lang.price || 'Price' }}</p>
                                    <v-text-field v-model="newProduct.price" 
                                    :error-messages="responseErrors.price" :hide-details="!responseErrors.price"
                                    @focus="responseErrors.price=''" outlined dense></v-text-field>
                                </v-col>
                                <v-col cols="12"> 
                                    <p class="custom-label">{{ $page.props.lang.category || 'Category' }}</p>
                                    <v-select v-model="newProduct.category_id" 
                                            :items="categoriesData"
                                            item-text="name"
                                            item-value="id"
                                            :error-messages="responseErrors.category_id" @change="responseErrors.category_id=''" 
                                            class="period-select" outlined dense :hide-details="!responseErrors.category_id"></v-select>
                                        <a href="javascript:void(0)"  @click="addCategoryModal = true" class="mt-1"> {{ $page.props.lang.addNewCategory || "Create New Category" }} </a>
                                </v-col>
                                <v-col cols="12">
                                    <v-switch
                                        v-model="newProduct.is_available"
                                        :label="$page.props.lang.is_available || `Mark as available`"
                                    ></v-switch>
                                </v-col>
                            </v-row>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn @click="newProductModal = false" color="regular">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                                <v-btn @click="addProduct" :loading="savingProduct" color="primary">{{ $page.props.lang.save || "Save" }}</v-btn>
                            </v-card-actions>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-dialog v-model="editProductModal" max-width="500px">
                <v-card>
                   <div class="modal-header">
                    <h4 class="modal-headline">{{ $page.props.lang.editProduct || "Edit product" }}</h4>
                    <div class="tools">
                        <v-btn icon @click="editProductModal = false"><v-icon>mdi-close</v-icon></v-btn>
                    </div>
                </div>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12">
                                    <p class="custom-label">{{ $page.props.lang.name || 'Name' }}</p>
                                    <v-text-field v-model="productForEdit.name" 
                                    :error-messages="responseErrors.name" :hide-details="!responseErrors.name"
                                    @focus="responseErrors.name=''" outlined dense></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <p class="custom-label">{{ $page.props.lang.sku || 'Sku' }}</p>
                                    <v-text-field v-model="productForEdit.sku" 
                                    :error-messages="responseErrors.sku" :hide-details="!responseErrors.sku"
                                    @focus="responseErrors.sku=''" outlined dense></v-text-field>
                                </v-col>
                                <!-- <v-col cols="12">
                                    <p class="custom-label">{{ $page.props.lang.quantity || 'Quantity' }}</p>
                                    <v-text-field v-model="productForEdit.qty" 
                                    :error-messages="responseErrors.qty" :hide-details="!responseErrors.qty"
                                    @focus="responseErrors.qty=''" outlined dense></v-text-field>
                                </v-col> -->
                                <v-col cols="12">
                                    <p class="custom-label">{{ $page.props.lang.unit || 'Unit' }}</p>
                                    <v-text-field v-model="productForEdit.unit" 
                                    :error-messages="responseErrors.unit" :hide-details="!responseErrors.unit"
                                    @focus="responseErrors.unit=''" outlined dense></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <p class="custom-label">{{ $page.props.lang.price || 'Price' }}</p>
                                    <v-text-field v-model="productForEdit.price" 
                                    :error-messages="responseErrors.price" :hide-details="!responseErrors.price"
                                    @focus="responseErrors.price=''" outlined dense></v-text-field>
                                </v-col>
                                <v-col cols="12"> 
                                    <p class="custom-label">{{ $page.props.lang.category || 'Category' }}</p>
                                    <v-select v-model="productForEdit.category_id" 
                                            :items="categoriesData"
                                            item-text="name"
                                            item-value="id"
                                            :error-messages="responseErrors.category_id" @change="responseErrors.category_id=''" 
                                            class="period-select" outlined dense :hide-details="!responseErrors.category_id"></v-select>                        
                                </v-col>
                                <v-col cols="12">
                                    <v-switch
                                        v-model="productForEdit.is_available"
                                        :label="$page.props.lang.is_available || `Mark as available`"
                                    ></v-switch>
                                </v-col>
                            </v-row>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn @click="editProductModal = false" color="regular">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                                <v-btn @click="editProduct" color="primary">{{ $page.props.lang.save || "Save" }}</v-btn>
                            </v-card-actions>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-dialog v-model="addCategoryModal" max-width="500px">
            <v-card>
                <div class="modal-header">
                    <h4 class="modal-headline">{{ $page.props.lang.newCategory || "New category" }}</h4>
                    <div class="tools">
                        <v-btn icon @click="addCategoryModal = false"><v-icon>mdi-close</v-icon></v-btn>
                    </div>
                </div>
                <v-card-text>
                    <v-container>
                            <v-row>
                                <v-col cols="8">    
                                    <p class="custom-label">{{ $page.props.lang.category_name || 'Category name' }}</p>
                                    <v-text-field v-model="newCategory.name" 
                                    :error-messages="responseErrors.name" :hide-details="!responseErrors.name"
                                    @focus="responseErrors.name=''" outlined dense></v-text-field>
                                </v-col> 
                                <v-col cols="4">
                                    <v-btn @click="saveCategory" :loading="savingCategory" color="primary" class="mt-6 ml-8">{{ $page.props.lang.save || "Save" }}</v-btn>
                                </v-col>    
                            </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
            <div class="table-container">
                <v-data-table
                :headers="productsHeaders"
                :items="productsData.data"
                :server-items-length="products.total"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                @update:sort-desc="sortTable"
                @update:sort-by="sortTable"
                :loading="loadingTable"
                item-key="item.id"
                mobile-breakpoint="0"
                hide-default-footer 
                >
                    <template v-slot:item.sku="{ item }">
                        {{ item.sku }}
                    </template>
                    <template v-slot:item.name="{ item }">
                        {{ item.name }}
                    </template>
                    <!-- <template v-slot:item.qty="{ item }">
                        {{ item.qty }}
                    </template> -->
                    <template v-slot:item.unit="{ item }">
                        {{ item.unit }}
                    </template>
                    <template v-slot:item.price="{ item }">
                        {{ item.price }} <span class="table-currency">{{ $page.props.organization.settings.currency }}</span>
                    </template>
                    <template v-slot:item.category_id="{ item }">
                        {{ item.category.name }}
                    </template>
                    <template v-slot:item.action="{ item }">
                        <v-btn @click="openEditProduct(item)" :id="'edit' + item.id" icon>
                                <v-icon>mdi-pencil-outline</v-icon>
                                <v-tooltip :activator="'#edit'+ item.id" bottom open-delay="500">
                                    <span>{{$page.props.lang.edit || "Edit"}}</span>
                                </v-tooltip>
                        </v-btn>
                        <v-btn @click="openDeleteModal(item)" :id="'delete' + item.id" class="delete-icon" icon>
                                <v-icon>mdi-trash-can-outline</v-icon>
                                <v-tooltip :activator="'#delete'+ item.id" bottom open-delay="500">
                                    <span>{{$page.props.lang.delete || "Delete"}}</span>
                                </v-tooltip>
                        </v-btn>
                    </template>
                </v-data-table>
                <ConfirmModal 
                    :title="$page.props.lang.confirmModalTitle || 'Confirmation'" 
                    :description="$page.props.lang.delete_confirmation_description || 'If you click YES, the product will be permanently deleted. Are you sure?'" 
                    :open="deleteModal" 
                    @no="deleteModal = false" 
                    @yes="deleteProduct" 
                    @close="deleteModal = false">
                </ConfirmModal>
            </div>
            <pagination :links="products.links" />
        </div>
    </products-layout>
</template>

<script>
import ProductsLayout from '@/js/Layouts/ProductsLayout'
import Pagination from '@/js/Components/Pagination'
import ConfirmModal from '@/js/Components/ConfirmModal'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'
import EventBus from '@/js/eventbus'

export default {
    metaInfo() {
        return {
            title:  this.$page.props.lang.title || "List of Products"
        }
    },
    components: {
        ProductsLayout,
        Pagination,
        ConfirmModal
    },
    props: {
        products: Object,
        categoryList: Array,
        filters: Object,
        lang: Object,
        locale: String
    },
    data(){
        return {
            form: {
                search: this.filters.search,
                category_id: this.filters.category_id
            },
            productsData: this.products,
            categoriesData: this.categoryList,
            productsHeaders: [
                {text: this.$page.props.lang.sku || "Product Key", value: 'sku', sortable: false, align:'start'},
                {text: this.$page.props.lang.name || 'Name', value: 'name', sortable: false, align:'start'},
                {text: this.$page.props.lang.category || 'Category', value: 'category_id', sortable: false, align:'left'},
                // {text: this.$page.props.lang.quantity || 'Quantity', value: 'qty', sortable: false, align:'left'},
                {text: this.$page.props.lang.unit || 'Unit', value: 'unit', sortable: false, align:'center'},
                {text: this.$page.props.lang.price || 'Price', value: 'price', sortable: false, align:'right'},
                {text: '', value: 'action', sortable: false, align: 'end'}        
            ],
            savingProduct: false,
            addCategoryModal: false,
            newCategory: {
            name: '',
            type: 'product'
            },
            responseErrors: {},
            messageObjects: [],
            selectedCategoryId: null,
            editProductModal: false,
            productForEdit: {
                
            },
            editProductMessage: {},
            prodDeleteMessage: {},
            newProductModal: false,
            newProduct: {},
            responseErrors: {},
            deleteModal: false,
            productForDeleteId: null,
            page: null,
            sortBy: [],
            sortDesc: [],
            search: null,
            loadingTable: false,
            savingCategory: false
        }
    },
    computed: {
        fullQuery() {
            let query = '?'
            this.form.search ? query += '&search='+this.form.search : ''
            this.selectedCategoryId ? query += '&category_id='+this.selectedCategoryId : ''
            this.form.search===null && this.selectedCategoryId===null ? query = 'remember=forget' : ''
            return query;
        }
    },
    watch: {
        form: {
            handler: throttle(function() {
                let queryForm = pickBy(this.form)
                let query = '?'
                Object.keys(query).length ? query += '&search='+queryForm.search : ''
                this.selectedCategoryId ? query += '&category_id='+this.selectedCategoryId : ''
                Object.keys(query).length===null && this.selectedCategoryId===null ? query = 'remember=forget' : ''
                this.$inertia.replace("/backoffice/products"+query)
                .then(() => {
                    this.productsData = this.products
                })            
            }, 250),
            deep: true
        },
        editProductModal: function(value) {
            if (value===false) {
              this.responseErrors = {}
            }
        }
    },
    methods: {
        sortTable() {
            console.log('sort')
        },
        categorySelected() {
            if(this.selectedCategoryId !== null) {
                this.$inertia.replace("/backoffice/products"+this.fullQuery)
                .then(() => {
                    this.productsData = this.products
                });
            }
        },
        resetFilters() {
            this.form.search = ''
            this.selectedCategoryId = null
            this.$inertia.replace("/backoffice/products?remember=forget")
            .then(() => {
                    this.productsData = this.products
                });
        },
        openEditProduct(item) {
             this.responseErrors = {};
             axios.get('/backoffice/products/getProduct/'+ item.id)
                .then(response => {
                    if(response.data.status === "OK"){
                        this.editProductModal = true;
                        this.productForEdit = response.data.product
                    }else{
                        alert(response.data.message)
                    }
                });
        },
        editProduct() {
            axios.put('/backoffice/products/update', this.productForEdit)
                .then(response => {                 
                    if (response.data.status==="OK") {      
                        this.editProductModal = false;
                        this.$inertia.visit('/backoffice/products', {only: ['products']});   
                        EventBus.$emit('SHOW_NOTIFICATION',{  
                                message: response.data.message,
                                color: 'success',
                                timeout: 5000
                            })
                    }
                })
                .catch(error => {                   
                   EventBus.$emit('SHOW_NOTIFICATION',{ 
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                    this.responseErrors = error.response.data.errors
                })
        },
        openDeleteModal(item) {
            this.deleteModal = true
            this.productForDeleteId = item.id
        },
        deleteProduct() {
            axios.post('/backoffice/products/delete', {id: this.productForDeleteId})
                .then(response => {
                    if(response.data.status==="OK") {
                        this.$inertia.visit('/backoffice/products', {only: ['products']});
                        EventBus.$emit('SHOW_NOTIFICATION',{ 
                                message: response.data.message,
                                color: 'success',
                                timeout: 5000
                            })
                    }
                })
                .catch(function (error) {
                     EventBus.$emit('SHOW_NOTIFICATION',{ 
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                    this.responseErrors = error.response.data.errors
                })
            this.deleteModal = false
        },
        addProduct() {
            this.savingProduct = true;
            axios.post('/backoffice/products/store', this.newProduct)
                .then(response => {
                    this.savingProduct = false;
                    if (response.data.status==="OK") {
                        this.newProductModal = false;
                        this.$inertia.visit('/backoffice/products', {only: ['products']});
                        EventBus.$emit('SHOW_NOTIFICATION',{ 
                                    message: response.data.message,
                                    color: 'success',
                                    timeout: 5000
                                })
                    }
                })
                .catch(error => {
                    this.savingProduct = false;
                    EventBus.$emit('SHOW_NOTIFICATION',{ 
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                    this.responseErrors = error.response.data.errors
                })
        },

        saveCategory(){
            this.savingCategory = true;
            axios.post('/backoffice/products/saveCategory', this.newCategory)
                .then(response => {
                    if (response.data.status==="OK") {
                        this.savingCategory = false;
                        this.addCategoryModal = false
                        this.categoriesData.push({id: response.data.category.id, name: response.data.category.name});
                        this.newProduct.category_id = response.data.category.id; 
                        EventBus.$emit('SHOW_NOTIFICATION',{ 
                            message: response.data.message,
                            color: 'success',
                            timeout: 2000
                        })
                    }
                })
                .catch(error => {      
                    this.savingCategory = false;             
                    EventBus.$emit('SHOW_NOTIFICATION',{ 
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                    this.responseErrors = error.response.data.errors
                })
        }

        
    }
}
</script>
